import { EventCallback } from "Global/Base/Events";
import { IHasFrameContext } from "UI/UI/UI/Controls/ControlInterfaces";
import { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { EditableControl } from "../../../../../UI.BaseControls/EditableControl";
import { GenericControl } from "../../../../../UI.BaseControls/GenericControl";
import { IDropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownInterfaces";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { FrameContext } from "../../../UIManagerInterfaces";
import { FilterBlock } from "../FilterBlock";
import { FilterGroup } from "../FilterGroup";
import { FilterRegistrations } from "../FilterRegistrations";

export class DropDownMenuFilterItem extends DropDownMenuItem implements IDropDownMenuItem, IHasFrameContext {
    public isClickable: boolean = false;

    private _filterBlock: FilterBlock;
    private _attrName: string;
    // @ts-ignore // nevyužito, ale ponecháno
    private _dataType: string;
    private _displayFormat: string;
    // @ts-ignore // nevyužito, ale ponecháno
    private _locKeyFilter: string;
    private _lastVisibleFilterGroup: FilterGroup;
    private _noFilterElement: HTMLElement;
    private _filterBtn: HTMLElement; // tlačitko filtrovat
    private _currentVisibleGroups: FilterGroup[];
    /** Kontext framu */
    public frameContext: FrameContext | undefined = undefined;
    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public override set locKey(v: string) {
        this._locKey = v;
    }

    public override get locKey(): string {
        return this._locKey;
    }

    public get attrName(): string {
        return this._attrName;
    }

    public set attrName(v: string) {
        this._attrName = v;
        this._setFBlockData();
    }
    public set dataType(v: string) {
        this._dataType = v;
        this._setFBlockData();
    }

    public get displayFormat(): string {
        return this._displayFormat;
    }

    public set displayFormat(v: string) {
        this._displayFormat = v;
    }

    public get filterBlock(): FilterBlock {
        return this._filterBlock;
    }

    public set filterBlock(filterBlock: FilterBlock) {
        // odregistrovani stare udalosti
        if (this._filterBlock && this._executeListener) {
            let registerEventBlock = this._filterBlock;
            if (this._filterBlock.parentFilterBlock) {
                registerEventBlock = this._filterBlock.parentFilterBlock;
            }
            registerEventBlock.filterExecuted.remove(this._executeListener);
            this._filterBlock.filterGroupRestored.remove(this._filterGroupRestoredListener);
            this._filterBlock.filterGroupRemoved.remove(this._filterGroupRemovedListener);
        }

        this._filterBlock = filterBlock;
        this._textElement.innerHTML = "";
        if (this._filterBlock) {
            this._textElement.appendChild(this._filterBlock);
            // registrace udalosti pro zavreni okna po provedeni filtrovani
            let registerEventBlock = this._filterBlock;
            if (this._filterBlock.parentFilterBlock) {
                registerEventBlock = this._filterBlock.parentFilterBlock;
            }

            registerEventBlock.filterExecuted.add(this._executeListener = () => {
                this.parent.closeAll();
            });

            this._filterBlock.filterGroupRemoved.add(this._filterGroupRemovedListener = (_fGroup, prm) => {
                this.createEmptyFilterGroup();
                if (prm.temporarily) {
                    this._filterBlock.filterGroupRestored.add(() => { // Pokud byla obnovena dočasně odstraněná FilterGroup, tak je potřeba odstranit ty nově vytvořené (tedy ty co nemají příznak isRemoving)
                        for (const group of this._filterBlock.groups) {
                            if (!group.isRemoving) {
                                group.remove();
                            }
                        }
                    });
                }
            });
        }
        this._textElement.appendChild(this._noFilterElement);
        this._setFBlockData();
    }

    private _executeListener: any;
    private _filterGroupRemovedListener: EventCallback<FilterGroup, {temporarily: boolean}>;
    private _filterGroupRestoredListener: EventCallback<FilterGroup, void>;

    private _addGroup(grp: FilterGroup): void {
        grp.style.display = "flex";
        this._currentVisibleGroups.push(grp);
    }

    private _removeGroup(grp: FilterGroup): void {
        grp.style.display = "none";
    }

    protected override _constructor(): void {
        super._constructor();

        this._filterBtn = createElement({ type: "button", classes: ["btn-filter", "btn", "primary"], value: "Filtrovat" });
        Localization.addLocData(this._filterBtn, "GUI-280088");//Filtrovat
        GenericControl.registerEventListener(this._filterBtn, "click", () => {
            if (this._filterBlock.classList.contains("Disabled"))
                return;
            this._filterBlock.execute();
        });
        this.appendChild(this._filterBtn);
        this._filterBtn.style.display = "none";

        this._currentVisibleGroups = [];
        this.visible = true;
        this._noFilterElement = createElement({ classes: "no-filter" });
        const noFilterText = document.createElement("span");
        this._noFilterElement.appendChild(noFilterText);
        Localization.getTextPromise("GUI-602542")
            .then((item) => {
                noFilterText.textContent = item;
            });

        this._textElement.appendChild(this._noFilterElement);
    }

    public override focus(): void {
        self.setTimeout(() => {
            if (this._lastVisibleFilterGroup) {
                let el: HTMLElement = this._lastVisibleFilterGroup.querySelector(".EditableControl");
                if (!el) {
                    el = this._lastVisibleFilterGroup.querySelector(".FilterCombo");
                }
                if (!el)
                    return;
                if (el instanceof EditableControl && !el.isAttached)
                    (this.querySelector(".EditableControl") as HTMLElement).focus();
                else
                    el.focus();
            }
        }, 100);
    }

    private _setFBlockData(): void {
        if (!this._attrName)
            return;

        if (this._currentVisibleGroups.length > 0) {
            this._currentVisibleGroups[0].canDelete = true;
            this._currentVisibleGroups[0].canFirstItemDelete = true;
        }
        this._currentVisibleGroups = [];

        if (this._filterBlock) {
            this._noFilterElement.style.display = "none";
            this._filterBtn.style.display = "block";

            let added = false;

            for (const grp of this._filterBlock.groups) {
                if (StringUtils.compareCaseInsensitive(grp.attrName, this._attrName)) {
                    this._addGroup(grp);

                    if (!added)
                        this._lastVisibleFilterGroup = grp;
                    added = true;
                } else
                    this._removeGroup(grp);
            }

            // pokud nebyla pridana zadna skupina je treba vytvorit prazdnou
            if (!added) {
                const filterGroupCreationCancelled = this.createEmptyFilterGroup();
                if (filterGroupCreationCancelled) {
                    return;
                }
            }
            if (this._currentVisibleGroups.length == 0) {
                this._currentVisibleGroups[0].canDelete = false;
                this._currentVisibleGroups[0].canFirstItemDelete = false;
            }
        }
    }

    public createEmptyFilterGroup(): boolean {
        const colInfo = this._filterBlock.attrNameToDataType.get(this._attrName);
        if (!colInfo)
            return true;

        const struct = FilterRegistrations.getDataTypeFilter(colInfo);
        if (struct == undefined) {
            this._noFilterElement.style.display = "block";
            this._filterBtn.style.display = "none";
            return true;
        }
        // vytvoření filtrovaci skupiny pro sloupec
        const grp = new FilterGroup();

        grp.setLocKey(colInfo.locKey, colInfo.locParams);
        grp.frameContext = this.frameContext;
        grp.filterStructure = struct;
        grp.attrName = this._attrName;
        grp.parentMenu = this.parent;
        grp.displayFormat = this.displayFormat;

        this._lastVisibleFilterGroup = grp;
        this._filterBlock.addGroup(grp);
        this._currentVisibleGroups.push(grp);
        return false;
    }

    public setFilterData(dataType: string, locKey: string): void {
        this._dataType = dataType;
        this._locKeyFilter = locKey;
        this._setFBlockData();
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "FilterBlockItem");
        this._textElement = document.createElement("div");
        this._textElement.innerHTML = "";
        this.appendChild(this._textElement);
    }

    protected override _setListener(): void {
        // Nechceme registrovat nic z předka
    }

    public override dispose(): void {
        GenericControl.unregisterEventListener(this._filterBtn, "click");
        this._currentVisibleGroups = [];

        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuFilterItem", DropDownMenuFilterItem);
